<app-header></app-header>
<div class="error">
  <div class="container-12 pr-32px desktop">
    <div class="row align-items-center">
      <div class="col center">
        <h2>{{i18n.ERROR.PAGE_NOT_FOUND}}</h2>
      </div>
    </div>
  </div>
  <div class="container-12 pt-20px mobile center">
    <div class="row align-items-center">
      <div class="col center">
        <h2>{{i18n.ERROR.PAGE_NOT_FOUND}}</h2>
      </div>
    </div>
  </div>
</div>
